import { TDotNotation, TUserDataCamel } from '@/types';

type TUserDataPath = NonNullable<TDotNotation<TUserDataCamel>>;
type TRequiredUserDataPath =
  | TUserDataPath
  | 'phone.number'
  | 'meta.fax.number'
  | 'meta.height'
  | 'meta.weight';

export const REQUIRED_FIELDS_BASIC: TUserDataPath[] = ['firstName', 'lastName'];

const REQUIRED_LOCATION_FIELDS: TUserDataPath[] = [
  'userLocation.address1',
  'userLocation.address2',
  'userLocation.city',
  'userLocation.country',
  'userLocation.state',
  'userLocation.zip',
];

// ===================== PATIENTS =====================

export const REQUIRED_FIELDS_PATIENT: TRequiredUserDataPath[] = [
  ...REQUIRED_FIELDS_BASIC,
  'timezone',
];

export const REQUIRED_FIELDS_PATIENT_DOSESPOT: TRequiredUserDataPath[] = [
  ...REQUIRED_LOCATION_FIELDS,
  'dob',
  'gender',
  'phone.number',
];

export const REQUIRED_FIELDS_PATIENT_UNDER_19: TRequiredUserDataPath[] = [
  'meta.height',
  'meta.weight',
];
// ===================== PROVIDERS =====================

export const REQUIRED_FIELDS_PROVIDER: TRequiredUserDataPath[] = [
  ...REQUIRED_FIELDS_BASIC,
  'medicalSpecialties',
  'licenseLocations',
  'languagesSpoken',
  'timezone',
];

export const REQUIRED_FIELDS_PROVIDER_DOSESPOT: TRequiredUserDataPath[] = [
  ...REQUIRED_LOCATION_FIELDS,
  'phone.number',
  'meta.fax.number',
];

// ===================== DEVICES =====================
export const REQUIRED_FIELDS_DEVICE: TUserDataPath[] = ['firstName'];
